import Box from "@mui/material/Box";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import PTRCard from "../components/PTRCard";
import { Produit } from "../../../models/Produit";
import {
  useGetCollectionsQuery,
  useGetFournisseursQuery,
  useGetModelesQuery,
  useGetProduitsQuery,
} from "../../../redux/features/cache";
import useGetPollingInterval from "../../../hooks/useGetPollingInterval";

export interface IPTRModal {
  handleCardClick: any;
}

export default function PTRModal({ handleCardClick }: IPTRModal) {
  const [fournisseur, setFournisseur] = useState<string>("");
  const [modele, setModele] = useState<string>("");
  const [collection, setCollection] = useState<string>("");
  const [rech, setRech] = useState<string>("");
  const pollingInterval = useGetPollingInterval();
  const { data: modeles = [] } = useGetModelesQuery(
    { four: fournisseur, withProd: "true" },
    { skip: fournisseur === "" }
  );
  const { data: collections = [] } = useGetCollectionsQuery(
    { four: fournisseur, mod: modele ? modele : "", treeView: false },
    { skip: fournisseur === "", pollingInterval: pollingInterval }
  );
  const { data: produits = [] } = useGetProduitsQuery({
    Four: fournisseur,
    Mod: modele,
    Coll: collection,
  });
  const { data: fournisseurs = [] } = useGetFournisseursQuery(
    { rech, withMod: "true", treeView: false },
    { skip: !rech }
  );

  const getAutocomplete = async (event: any) => {
    let inputValue = event.target.value;
    setRech(inputValue);
  };

  return (
    <div>
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
        <Autocomplete
          options={fournisseurs}
          clearOnBlur={false}
          getOptionLabel={(cat) => `${cat.four_cd} ${cat.four_nom}`}
          onInputChange={(event) => {
            getAutocomplete(event);
          }}
          onChange={(_event, newValue: any) => {
            setFournisseur(newValue ? newValue.four_cd : "");
          }}
          sx={{ width: 300, m: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{ color: "#233044", background: "white" }}
              {...params}
              label="Fournisseur"
            />
          )}
        />
        <Autocomplete
          disabled={fournisseur ? false : true}
          options={collections}
          clearOnBlur={false}
          getOptionLabel={(mod) => `${mod.prod_collection}`}
          onInputChange={async (_event, newInputValue) => {
            setCollection(newInputValue);
          }}
          sx={{ width: 300, m: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{ color: "#233044", background: "white" }}
              {...params}
              label="Collection"
            />
          )}
        />

        <Autocomplete
          disabled={fournisseur ? false : true}
          options={modeles}
          clearOnBlur={false}
          getOptionLabel={(mod) => `${mod.mod_cd}`}
          onInputChange={async (event, newInputValue) => {
            event?.stopPropagation();
            let key = modeles.find((e) => e.mod_cd === newInputValue)!.mod_cd;
            setModele(key);
          }}
          sx={{ width: 300, m: 1 }}
          renderInput={(params) => (
            <TextField
              sx={{ color: "#233044", background: "white" }}
              {...params}
              label="Modele"
            />
          )}
        />
      </Box>
      <Box
        sx={{
          overflow: "auto",
          maxHeight: "60vh",
          mt: 4,
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
        }}
      >
        {produits &&
          produits.map((e: Produit, i) => (
            <PTRCard
              handleCardClick={handleCardClick}
              data={e}
              key={`${i}+${e.prod_num}`}
            />
          ))}
      </Box>
    </div>
  );
}
